// Button types
import { ButtonOptions } from '../input/types';

/**
 *  Available type of modal, based on which the correct icon and colors are used.
 */
export enum ModalType {
    /** Using yellow and the info icon. */
    Info = 'info',

    /** Using orange and the warning icon. */
    Warning = 'warning',

    /** Using red and the warning icon. */
    Error = 'error',
}

/**
 *  Options of an interactive modal.
 */
export interface InteractiveModalOptions {
    /** The title of the modal. */
    title?: string;

    /** The body of the modal, supporting HTML. */
    body: string;

    /** The optional cancel button. */
    cancel?: ButtonOptions;

    /** The optional confirm button. */
    confirm?: ButtonOptions;

    /** The optional width of the modal. */
    width?: string;
}
